<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Versión Por Revisión Anexo</h1>
</div>

<div class="divider-butons-VH">
  <button (click)="See_Flow_Annexe()" class="btn btn-icon-text-left">
    <span class="text">Flujo de anexo</span><i class="fa-regular fa-circle-question"></i>
  </button>
</div>

<div class="container-global-components ConVH">

  <div class="Table-Lib Table-container-Global">

    <p-table #dt [value]="List_Histrory_Version_Annexe" [(selection)]="SelectedList_Histrory_Version_Annexe"
      dataKey="id" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]"
      [paginator]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      [filterDelay]="0" [globalFilterFields]="['Name','FIN_Name','Contributor_Name']">

      <ng-template pTemplate="caption">

        <!--?===== INPUT FOR FIN SEARCH =====?-->
        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">

            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Filter_VersionHA" type="text"
                (input)="dt.filterGlobal(Filter_VersionHA, 'contains')"
                placeholder="Buscar en historial de versiones" />
            </div>
          </div>
          <div class="right-CT">

          </div>
        </div>

      </ng-template>

      <ng-template pTemplate="header">

        <tr>

          <ng-container *ngFor="let Table_Header of HeadersVH_Annexe">

            <ng-container *ngIf="Table_Header.Key_Header === 'DOWNA'">
              <th class="{{Table_Header.Key_Header}}">{{Table_Header.Name}}</th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NAMAN'">

              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>

            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NAMEF'">

              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="text" field="FIN_Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>

            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'CONTR'">

              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter field="Contributor_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre contribuidor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>

            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DACRE'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="date" field="Upload_Date" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'STATU'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter field="Status" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Estatus</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Status" placeholder="Seleccione"
                          (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>
                                  <div [ngSwitch]="option">
                                    <div *ngSwitchCase='1'>Carga nueva</div>
                                    <div *ngSwitchCase='2'>Anexo actualizado</div>
                                    <div *ngSwitchCase='3'>Anexo sin actualización</div>
                                    <div *ngSwitchCase='4'>Anexo eliminado por actualización</div>
                                    <div *ngSwitchCase='5'>Anexo eliminado</div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>


          </ng-container>

        </tr>

      </ng-template>

      <ng-template pTemplate="body" let-List_Histrory_Version_Annexe let-i="rowIndex">

        <tr>

          <td *ngFor="let Table_Header of HeadersVH_Annexe">

            <ng-container *ngIf="Table_Header.Key_Header === 'DOWNA'">
              <button (click)="Download_Annexe(List_Histrory_Version_Annexe,i)"
              [disabled]="!(UserRoleIn([PermissionFIN.downloadVersionAnnexe]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN]))"
                class="Btn-Download-Local Btn-Download-Global" id="Btn-Download{{i}}">
                <div class="Content-Download">
                  <span class="Progress-Bar-Task" id="Progress-Bar-Task{{i}}"></span>
                  <span class="Btn-Text" id="Text-Btn{{i}}">{{(UserRoleIn([PermissionFIN.downloadVersionAnnexe]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])) ?
                    'Descargar':'Sin Permisos'}}</span>
                  <i class="fa-solid fa-cloud-arrow-down" id="Icon-Btn{{i}}"></i>
                </div>
              </button>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NAMAN'">
              {{List_Histrory_Version_Annexe.Name}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NAMEF'">
              {{List_Histrory_Version_Annexe.FIN_Name}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'CONTR'">
              {{List_Histrory_Version_Annexe.Contributor_Name}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DACRE'">
              {{Date_Format(List_Histrory_Version_Annexe.Upload_Date)}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'STATU'">
              <div class="ContainerStatus">
                <div class="StatusTool SA{{List_Histrory_Version_Annexe.Status}}"></div>
                {{Status_string(List_Histrory_Version_Annexe.Status)}}
              </div>
            </ng-container>


          </td>

        </tr>

      </ng-template>



    </p-table>

  </div>

</div>



<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
